import TipoService from "@/api/services/finanzas/nomencladores/TipoService"
import Vue from "vue"

const state = () => ({
    tipos: [],
    pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 10,
        sortBy: "nombre",
        rowsPerPageItems: [5, 10, 20, 30, 40, 50]
    }
})

const getters = {
    TIPOS: state => {
        return state.tipos
    },
    TIPOS_PAG: state => {
        return state.pagination
    }
}

const mutations = {
    SET_TIPOS: (state, payload) => {
        state.tipos = payload
    },

    SET_TIPOS_PAG: (state, payload) => {
        state.pagination = payload
    },

    ADD_TIPO: (state, payload) => {
        state.tipos.push(payload)
    },

    UPDATE_TIPO: (state, payload) => {
        state.tipos = state.tipos.map(el => (el.id === payload.id ? payload : el))
    },

    DELETE_TIPO: (state, payload) => {
        state.tipos = state.tipos.filter(el => el.id !== payload.id)
    }
}

const actions = {
    LOAD_TIPOS: async ({ commit, state }, { filter, tipoEstado }) => {
        try {
            let pagination = {
                page: state.pagination.page,
                rowsPerPage: state.pagination.rowsPerPage,
                sortBy: state.pagination.descending ? "-" + state.pagination.sortBy : state.pagination.sortBy
            }
            let { data, status, headers } = await TipoService.get({ filter, tipoEstado, ...pagination })
            if (status === 200) {
                commit("SET_TIPOS", data)
                return parseInt(headers["x-pagination-total-count"])
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar los tipos del activo, inténtelo nuevamente"
            })
        }
    },

    LOAD_ALL_TIPOS: async ({ commit }) => {
        try {
            let { data, status } = await TipoService.getAll()
            if (status === 200) {
                commit("SET_TIPOS", data)
                return data
            }
        } catch (error) {
            if (error.response) {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    LOAD_ALL_RECORDS_TIPOS: async ({ commit }) => {
        try {
            let { data, status } = await TipoService.getAllRecords()
            if (status === 200) {
                commit("SET_TIPOS", data)
                return null
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar los tipos del activo, inténtelo nuevamente"
            })
        }
    },

    LOAD_HISTORY_ACTIVO_TIPO: async ({ commit }, payload) => {
        try {
            let { data, status } = await TipoService.getHistory(payload)
            if (status === 200) {
                commit("UPDATE_TIPO", data)
            }
            return null
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido cargar el historial para el tipo del activo, inténtelo nuevamente"
            })
        }
    },

    ADD_TIPO: async ({ commit }, payload) => {
        try {
            let { data, status } = await TipoService.post(payload)
            if (status === 201) {
                commit("ADD_TIPO", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Agregando",
                    text: "El tipo ha sido agregado satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido agregar el tipo, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    UPDATE_TIPO: async ({ commit }, payload) => {
        try {
            let { data, status } = await TipoService.put(payload)
            if (status === 200) {
                commit("UPDATE_TIPO", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Modificando",
                    text: "El tipo ha sido modificado satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido modificar el tipo, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    DELETE_TIPO: async ({ commit }, payload) => {
        try {
            let { status, data } = await TipoService.delete(payload)
            if (status === 204) {
                commit("DELETE_TIPO", payload)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Eliminando",
                    text: "El tipo ha sido eliminado satisfactoriamente"
                })
            }
            if (status === 200) {
                commit("UPDATE_TIPO", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Deshabilitando",
                    text: "El tipo ha sido deshabilitado satisfactoriamente"
                })
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido eliminar/deshabilitar el historial para el tipo del activo, inténtelo nuevamente"
            })
        }
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}
